import { render, staticRenderFns } from "./ShAddressEditor.vue?vue&type=template&id=6589ca00&scoped=true&"
import script from "./ShAddressEditor.vue?vue&type=script&lang=js&"
export * from "./ShAddressEditor.vue?vue&type=script&lang=js&"
import style0 from "./ShAddressEditor.vue?vue&type=style&index=0&id=6589ca00&lang=scss&scoped=false&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589ca00",
  null
  
)

export default component.exports